<template>
    <div :class="['hle-boq-builder-page', { 'hle-boq-builder-page--deluxe': isDeluxeLayout }]">
        <BreadcrumbsProject
        v-if="!isDeluxeLayout"
        :breadcrumbs="[
            {
                link : '/high-level-estimates',
                title : $t('Bidding'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities',
                title : (hleProject.projectName || '-' )+ ' - ' + $t('Bidding Module.Detailed Estimates'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities-builder/' + boqId,
                title :boqUrlname,
                isRouterLink: true
            },
        ]"
        />
        <div v-if="isDeluxeLayout" class="hle-boq-breakdown-back d-print-none">
            <router-link :to="{ name: 'HleBoqs', params: { id: hleProjectId } }">
                <i class="fa-solid fa-chevron-left"></i>
                {{ $t('Back to Previous Page') }}
            </router-link>
        </div>
        <div class="card hle-bidding-card hle-boq-builder-card">
            <div class="card-header bg-white hle-boq-builder-card__header">
                <div class="d-flex justify-content-between hle-boq-builder-header">
                    <div class="d-flex justify-content-center align-items-center hle-boq-builder-title">
                        <span class="hle-estimate-eyebrow">{{ $t('Bidding Module.Detailed Estimate') }}</span>
                        <h4 class="text-capitalize"> {{ boqItem.name || '-' }}</h4>
                    </div>
                    <div class="hle-boq-builder-actions">
                        <button type="button" class="btn btn-primary hle-boq-builder-action hle-boq-builder-action--primary" v-if="sectionList.length!=0 && !approvalItem" @click="SendForApproval">
                            <i class="fa-solid fa-file-pen"></i> 
                            {{ $t('Send For Approval') }} — {{ $t('Bidding Module.Detailed Estimate') }}
                        </button>
                        <ButtonTemplateDownloader
                        standard
                        group-class="hle-boq-builder-template-group"
                        button-class="hle-boq-builder-action hle-boq-builder-action--template"
                        />
                        <button class="btn btn-default hle-boq-builder-action hle-boq-builder-action--utility"
                        data-bs-toggle="modal" data-bs-target="#ModalImportBoq"
                        @click="OpenImportModal" ><i class="fa-solid fa-file-import"></i> {{$t('Import')}}  </button>
                        <button class="btn btn-default hle-boq-builder-action hle-boq-builder-action--utility" :title="$t('Export to File')"
                        data-bs-toggle="modal" data-bs-target="#BoqExportBoqList"
                        @click="()=>{ exportTemplateType= 0; }"><i class="fa-solid fa-file-export"></i> {{$t('Export')}} </button>
                        <router-link :title="$t('Print Bill of Quantity')" :to="{name : 'HleBoqItemsPrint', params : {id : hleProjectId, boqId : boqItem._id} }"  
                        class="btn btn-default hle-boq-builder-action hle-boq-builder-action--print"><i class="fa-solid fa-print"></i>  {{$t('Print')}}</router-link>
                    </div>
                    <!--  -->
                </div>
            </div>
            <div class="card-body hle-boq-builder-card__body">
                <div class="hle-boq-builder-alert hle-boq-builder-alert--approval" role="alert" v-if="approvalItem">
                    <span class="hle-boq-builder-alert__icon"><i class="fas fa-info-circle"></i></span>
                    <div class="hle-boq-builder-alert__content">
                        <strong>{{ $t('Bidding Module.Detailed Estimate') }}</strong>
                        <span>{{ $t('Bidding Module.This Detailed Estimate is awaiting approval') }}.</span>
                    </div>
                    <router-link class="hle-boq-builder-alert__action" :to="{name : 'HleBoqItemsApproval', params : {id : approvalItem._id}}">
                        {{ $t('Go to Approval') }}
                        <i class="fa-solid fa-arrow-right"></i>
                    </router-link>
                </div>
                <div class="hle-boq-builder-alert hle-boq-builder-alert--warning" role="alert" v-if="haveUnassignedLineItems">
                    <span class="hle-boq-builder-alert__icon"><i class="fas fa-info-circle"></i></span>
                    <div class="hle-boq-builder-alert__content">
                        <strong>{{ $t('Bidding Module.Detailed Estimate') }}</strong>
                        <span>{{ $t('Bidding Module.This Detailed Estimate has an unassigned Line items') }}.</span>
                    </div>
                    <router-link class="hle-boq-builder-alert__action" :to="{name : 'HleBoQBuilderUnassigneds', params : {id : hleProjectId, boqId : boqId}}">
                        {{ $t('Assign Line Items') }}
                        <i class="fa-solid fa-arrow-right"></i>
                    </router-link>
                </div>
                <div class="d-flex justify-content-between mb-2 hle-boq-builder-meta">
                    <div>
                        <span v-if="boqItem.reference">
                            <small class="text-muted">{{ $t('Reference High Level Estimate')}}: </small>
                            <router-link :to="{name : 'HleQuotation', params : { id : hleProjectId, qtnId : boqItem.reference._id} }" class="text-capitalize small text-primary fw-bold"> 
                                {{boqItem.reference.name}}
                            </router-link>
                        </span>
                    </div>
                    <div class="btn-group">
                        <span :class="['badge hle-bidding-status-pill', GetBoqStatusClass(boqItem.status)]">{{ ApprovalStageBoqObj[boqItem.status - 1].name}}</span>
                    </div>
                </div>
                <FigureCurrencyNote :currency="boqItem.currencyId" />
                <!-- <div class="d-flex justify-content-center fw-light">
                    <i>All monetary figures shown below are in {{ boqItem.currencyId?.name }} ({{ boqItem.currencyId?.sign }}) and are exclusive of tax</i>
                </div> -->
                <div class="d-flex justify-content-between mb-1">
                    <div>
                        
                    </div>
                    <div class="hle-boq-builder-sequence-actions" v-if="haveMoved">
                        <button class="btn hle-boq-builder-action hle-boq-builder-action--cancel" @click="CancelSaveSequence" >{{ $t('Cancel') }}</button>
                        <button class="btn hle-boq-builder-action hle-boq-builder-action--primary" @click="SaveSequences" ><i class="fa-solid fa-list-ol"></i> {{ $t('Save Sequence') }}</button>
                    </div>
                </div>
                <div class="hle-boq-builder-table-wrap">
                    <div class="d-flex fw-bold hle-boq-builder-table-row hle-boq-builder-table-row--head" style="background-color: #F5F6FA;" >
                    <div class=" p-2 border border-end-0 " :style="{width: BoqBuilderColumSizes.HANDLE}"></div>
                        <div class="p-2 border border-end-0" :style="{width: BoqBuilderColumSizes.DESCRIPTION}">{{ $t('Section') }}</div>
                        <div class="p-2 border border-end-0 " :style="{width: BoqBuilderColumSizes.COST_TOTAL}"> {{ $t('Total Cost') }} ({{boqItem.currencyId?.sign}})</div>
                        <div class="p-2 border border-end-0" :style="{width: BoqBuilderColumSizes.SELL_TOTAL}">  {{ $t('Total Sell') }} ({{boqItem.currencyId?.sign}})</div>
                        <div class="p-2 border border-end-0" :style="{width: BoqBuilderColumSizes.GP}">{{ $t('GP Total') }}  ({{boqItem.currencyId?.sign}})</div>
                        <div class="p-2 border border-end-0" :style="{width: BoqBuilderColumSizes.GP_PERCENTAGE}"> {{ $t('GP') }} %</div>
                        <div class="p-2 border" :style="{width: BoqBuilderColumSizes.ACTIONS}"></div>
                        
                    </div>
                    <div class="small p-2 border border-top-0 hle-boq-builder-add-row" style="min-height: 37.8px;" >
                        <div class=" text-end "  >
                            <small class="fw-bold hle-boq-builder-add-section" @click="OpenAddNewSection" role="button" data-bs-toggle="modal" data-bs-target="#BoQAddMainSectionModal">
                                <i class="fa-solid fa-plus"></i> {{ $t('Add Main Section') }}
                            </small>
                        </div>
                    </div>
                    <div class="" v-if="sectionList.length==0">
                        <div class="text-center p-2 border border-top-0 hle-boq-builder-empty">
                            <span class="fw-bold">{{ $t('No data Found') }}</span>
                        </div>
                    </div>
                    <div class="parent hle-boq-builder-table-body">
                        <BoqSectionRow :OpenRename="OpenRename" :BoqItem="boqItem" :OpenAddNewSubSection="OpenAddNewSubSection" :DeleteMain="DeleteMain" :SectionList="sectionList" :Level="1"
                        :OnEnd="OnEnd" :OpenMarkUp="OpenMarkUp" :IsQuotationPublished="IsQuotationPublished" :ToObject="{ name : 'HleBoqBuilderBreakdown', params : { id : hleProjectId, boqId : boqId} }" >
                        
                        </BoqSectionRow>
                    </div>
                    <div class="d-flex small fw-bold bg-light-primary hle-boq-builder-total-row" >
                        <div class="  p-2 border border-end-0 border-top-0" :style="{width: BoqBuilderColumSizes.HANDLE}">
                        </div>
                        <div class=" text-end p-2 border border-end-0 border-top-0 " :style="{width: BoqBuilderColumSizes.DESCRIPTION}">
                            <span class="fw-bold text-capitalize">{{ $t('Overall Total') }}</span>
                        </div>
                        <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.COST_TOTAL}">
                            {{ ReformatNumber(overAllTotal.costTotal) }}
                        </div>
                        <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.SELL_TOTAL}">
                            {{ ReformatNumber(overAllTotal.sellTotal) }}
                        </div>
                        <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP}">
                            {{ ReformatNumber(overAllTotal.gp) }}
                        </div>
                        <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP_PERCENTAGE}">
                            {{ ReformatNumber(overAllTotal.gpPercentage,0,2)  }}%
                        </div>
                        <div class="p-2 border border-top-0" :style="{width: BoqBuilderColumSizes.ACTIONS}">
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <Modal idModal="BoqExportBoqList" :headerTitle="$t('Export')" modalSize="modal-md" :busy="isExportRunning">
            <div class="form-group hle-section-modal-field">
                <label>
                    {{ $t('Template') }}
                    <span class="bidding-required-inline" v-if="!isExportTemplateSelected">({{ $t('Required').toLowerCase() }})</span>
                </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-file-export"></i>
                    </span>
                    <select class="form-select" v-model="exportTemplateType" :disabled="isExportRunning">
                        <option value="0">{{ $t('Please Select') }}</option>
                        <option value="1">{{ $t('System Template') }}</option>
                        <option value="2">{{ $t('System Template (For Presentation)') }}</option>
                    </select>
                </div>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeModalExportBoq" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" :disabled="isExportRunning" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!isExportTemplateSelected || isExportRunning" @click="ExportBoqList" >
                    <i v-if="!isDeluxeLayout && !isExportRunning" class="fa-solid fa-file-arrow-down"></i>
                    <span>{{ $t('Export') }}</span>
                    <span v-if="isExportRunning" class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>
                    <span v-if="isExportRunning" class="visually-hidden" role="status">{{ $t('Loading') }}</span>
                </button>
            </template>
        </Modal>
        <Modal idModal="ModalImportBoq" :headerTitle="$t('Import')" modalSize="modal-md" :busy="isImportRunning">
            <div class="hle-import-modal" :aria-busy="isImportRunning">
                <div class="form-group hle-import-modal__field">
                    <label>
                        {{$t('File')}}
                        <span class="bidding-required-inline" v-if="!newBoqImport.file">({{ $t('Required').toLowerCase() }})</span>
                    </label>
                    <input type="file" class="form-control hle-import-modal__input" ref="uploadFile" :disabled="isImportRunning" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="newBoqImport.file = $event.target.files[0]; importError = ''" />
                    <small class="text-warning" v-if="isImportClicked && !newBoqImport.file">{{ $t('Required') }} </small>
                </div>
                <div class="form-group hle-import-modal__field">
                    <div class="hle-import-modal__label-row">
                        <label>
                            {{ $t('Template') }}
                            <span class="bidding-required-inline" v-if="!isImportTemplateSelected">({{ $t('Required').toLowerCase() }})</span>
                        </label>
                        <button type="button" class="hle-import-modal__download" :disabled="isImportRunning" @click="DownloadTemplate">
                            <i class="fa-solid fa-download"></i>
                            {{$t('Download selected template')}}
                        </button>
                    </div>
                    <select class="form-select hle-import-modal__input" v-model="newBoqImport.importTemplateType" :disabled="isImportRunning">
                        <option value="0">{{ $t('Please Select') }}</option>
                        <option value="1">{{ $t('System Template') }}</option>
                    </select>
                    <small class="text-warning" v-if="isImportClicked && !isImportTemplateSelected">{{ $t('Required') }}</small>
                </div>
                <div v-if="isImportRunning" class="hle-import-modal__loading" role="status" aria-live="polite">
                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span>{{ $t('Import loading message') }}</span>
                </div>
                <div v-if="importError" class="hle-import-modal__error" role="alert">{{ importError }}</div>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeModalImportBoq" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" :disabled="isImportRunning" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isImportRunning || !isImportBoqReady" @click="ImportBoqList" >
                    <span v-if="isImportRunning" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                    <i v-else-if="!isDeluxeLayout" class="fa-solid fa-file-arrow-down"></i>
                    {{ isImportRunning ? $t('Importing file') : $t('Import') }}
                </button>
            </template>
        </Modal>
        <Modal idModal="RenameSectionModal" :headerTitle="$t('Update Section')" modalSize="modal-md" >
            <div class="form-group hle-section-modal-field">
                <label>
                    {{ $t('Section Name') }}
                    <span class="bidding-required-inline" v-if="!renameSection.name">({{ $t('Required').toLowerCase() }})</span>
                </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <input class="form-control" :placeholder="$t('Section Name')" v-model="renameSection.name" />
                </div>
                <small class="text-warning" v-if="isActionClicked && !renameSection.name">{{ $t('Required') }}</small>
            </div>
            <div class="form-group hle-section-modal-field" v-if="renameSection.level > 1 && renameSection.object?.childs.length ==0">
                <label > {{ $t('Estimate Amount') }} </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-coins"></i>
                    </span>
                    <input type="number" class="form-control" :placeholder="$t('Estimate Amount')" v-model="renameSection.expectedAmount" />
                </div>
                <small class="text-warning" v-if="isActionClicked && !newSubSection.expectedAmount">{{ $t('Required') }}</small>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeRenameSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!renameSection.name" @click="RenameSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Update')}}</button>
            </template>
        </Modal>
        <Modal idModal="BoQAddMainSectionModal" :headerTitle="$t('Add Main Section')" modalSize="modal-md" >
            <div class="form-group hle-section-modal-field">
                <label>
                    {{ $t('Section Name') }}
                    <span class="bidding-required-inline" v-if="!isAddMainSectionReady">({{ $t('Required').toLowerCase() }})</span>
                </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <input class="form-control" :placeholder="$t('Section Name')" v-model="newSection.name" />
                </div>
                <small class="text-warning" v-if="isActionClicked && !isAddMainSectionReady">{{ $t('Required') }}</small>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeBoQAddMainSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!isAddMainSectionReady" @click="AddMainSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Add')}}</button>
            </template>
        </Modal>
        <Modal idModal="BoQAddSubSectionModal" :headerTitle="$t('Add Sub Section')" modalSize="modal-md" >
            <div class="form-group hle-section-modal-field hle-section-modal-field--display">
                <label>{{ $t('Main Section Name') }} </label>
                <div class="hle-section-modal-display">
                    <span class="hle-section-modal-display__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <span class="hle-section-modal-display__value">{{ newSubSection.mainName || '' }}</span>
                </div>
            </div>
            <div class="form-group hle-section-modal-field">
                <label>
                    {{ $t('Sub Section Name') }}
                    <span class="bidding-required-inline" v-if="!isAddSubSectionReady">({{ $t('Required').toLowerCase() }})</span>
                </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-diagram-project"></i>
                    </span>
                    <input class="form-control" :placeholder="$t('Section Name')" v-model="newSubSection.name" />
                </div>
                <small class="text-warning" v-if="isActionClicked && !isAddSubSectionReady">{{ $t('Required') }}</small>
            </div>
            <div class="form-group hle-section-modal-field">
                <label >{{ $t('Estimate Amount') }} </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-coins"></i>
                    </span>
                    <input type="number" class="form-control" :placeholder="$t('Estimate Amount')" v-model="newSubSection.estimatedAmount" />
                </div>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeBoQAddSubSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!isAddSubSectionReady" @click="AddNewSubSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Add')}}</button>
            </template>
        </Modal>
        <Modal idModal="BoQMarkUpUpdateModal" :headerTitle="$t('Update Section Mark Up')" modalSize="modal-md" >
            <div class="form-group hle-section-modal-field hle-section-modal-field--display">
                <label>{{ $t('Section Name') }}</label>
                <div class="hle-section-modal-display">
                    <span class="hle-section-modal-display__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <span class="hle-section-modal-display__value text-capitalize">{{ markUpUpdate.name || '' }}</span>
                </div>
            </div>
            <div class="form-group hle-section-modal-field">
                <label>{{$t('Mark Up')}} </label>
                <div class="hle-section-modal-input hle-section-modal-input--with-suffix">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-percent"></i>
                    </span>
                    <input type="number" class="form-control"  v-model="markUpUpdate.markUp" max="100" min="0"/>
                    <span class="hle-section-modal-input__suffix">%</span>
                </div>
                <small class="text-warning" v-if="isActionClicked && ( markUpUpdate.markUp < 0 || markUpUpdate.markUp > 100)">{{ $t('Required') }}</small>
            </div>
            <template v-slot:actions>
                <button type="button" ref="closeBoQMarkUpUpdateModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
                <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="UpdateMarkUp"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Save')}}</button>
            </template>
        </Modal>
    </div>
</template>


<script>
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import {GetHighLevelBoq, ExportHighLevelBoqLineItems, ImportHighLevelBoqLineItems,DownloadTemplate1,
     GetApprovalItemHighLevelEstimates, GetHighLevelProject, GetHighLevelBoqLineItemsByBits,
     DeleteHleNewBoqCreatorSection, UpdateHleNewBoqCreatorSectionSequence, UpdateHleNewBoqCreatorSectionMarkUp,
     GetHleNewBoqCreatorSections, AddHleNewBoqCreatorSection, UpdateHleNewBoqCreatorSectionName} from '@/actions/boqActions.js'
import {LinkList, ApprovalStageBoqObj, ExportTemplates, ApprovalStageBoq, ReformatNumber, BoqBuilderColumSizes} from '@/helpers/utilities.js'
import  {mapActions, mapGetters} from 'vuex'
import ButtonTemplateDownloader from '@/components/boq/ButtonTemplateDownloader.vue'
import Modal from '@/components/layout/Modal.vue'
import BoqSectionRow from '@/components/boq/BoqSectionRow.vue'
import FigureCurrencyNote from '@/components/layout/FigureCurrencyNote.vue'
export default {
    name : 'HleBoQBuilder',
    mounted :async function(){
        const self = this
        const boqItem = await GetHighLevelBoq(self.boqId)
        self.boqItem = boqItem
        self.boqUrlname = boqItem.name  + ' - (' + boqItem.currencyId.sign +') '  + boqItem.currencyId.shortName  +' '+ boqItem.currencyId.name
        self.ChangeActiveLink(LinkList.HIGH_LEVEL_ESTIMATES)
        self.hleProject = await GetHighLevelProject(self.hleProjectId)
        await self.ReloadData()

        await self.CheckIfHaveUnassigned()
       
        if(boqItem.status==ApprovalStageBoq.FOR_APPROVAL){
            self.approvalItem = await GetApprovalItemHighLevelEstimates({boqId : boqItem._id})
        }
    },
    components : {
        BreadcrumbsProject,  Modal, ButtonTemplateDownloader, BoqSectionRow,
        FigureCurrencyNote
    },
    computed : {
        ...mapGetters(['boqCurrency']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        isAddMainSectionReady(){
            return String(this.newSection.name || '').trim().length > 0
        },
        isAddSubSectionReady(){
            return String(this.newSubSection.name || '').trim().length > 0
        },
        isImportTemplateSelected(){
            const templateType = String(this.newBoqImport.importTemplateType ?? '')
            return templateType !== '' && templateType !== '0'
        },
        isExportTemplateSelected(){
            const templateType = String(this.exportTemplateType ?? '')
            return templateType !== '' && templateType !== '0'
        },
        isImportBoqReady(){
            return Boolean(this.newBoqImport.file) && this.isImportTemplateSelected
        },
        IsQuotationPublished(){
            return false
        }
    },
    methods :{
        async CheckIfHaveUnassigned(){
            const self = this
            const getUnassingedLineItem = await GetHighLevelBoqLineItemsByBits({
                page : 1,
                id :  self.boqId,
                costCode : '',
                area : '',
                skip : 0,
                take : 3
            })
            
            self.unassignedLineItemsPreview = Array.isArray(getUnassingedLineItem) ? getUnassingedLineItem : []
            self.haveUnassignedLineItems = self.unassignedLineItemsPreview.length!=0
        },
        ...mapActions(['ChangeActiveLink', 'GetCurrencyListRun']),
        ReformatNumber,
        FormatLineItemLabel(lineItem){
            const costCode = String(lineItem?.costCode || '').trim()
            const name = String(lineItem?.name || lineItem?.nameCh || lineItem?.description || lineItem?._id || this.$i18n.t('Unnamed line item')).trim()

            return [costCode, name].filter(Boolean).join(' - ')
        },
        FormatUnassignedLineItemsMessage(lineItems){
            const examples = (lineItems || [])
                .map((lineItem)=>this.FormatLineItemLabel(lineItem))
                .filter(Boolean)

            const examplesText = examples.length > 0
                ? ` ${this.$i18n.t('Examples')}: ${examples.join(', ')}.`
                : ''

            return `${this.$i18n.t('Cannot send this Detailed Estimate for approval because some line items are not assigned to a section.')}${examplesText} ${this.$i18n.t('Open Assign Line Items and assign or delete them, then try again.')}`
        },
        GetBoqStatusClass(status){
            switch(Number(status)){
                case 1:
                case 2:
                case 3:
                    return 'hle-bidding-status-pill--pending'
                case 4:
                    return 'hle-bidding-status-pill--approval'
                case 5:
                case 8:
                    return 'hle-bidding-status-pill--approved'
                case 6:
                    return 'hle-bidding-status-pill--revision'
                default:
                    return 'hle-bidding-status-pill--neutral'
            }
        },
        GetImportErrorMessage(message){
            if(message && typeof message === 'object') message = message.message
            const normalizedMessage = String(message || '').trim().toLowerCase()
            if(normalizedMessage === 'header does not match'){
                return this.$i18n.t('Bidding Module.Import header mismatch message')
            }

            if(normalizedMessage === 'error on processing template'){
                return this.$i18n.t('Bidding Module.Import processing error message')
            }

            return message || this.$i18n.t('Something went wrong')
        },
        async CloseImportModal(){
            const button = this.$refs.closeModalImportBoq
            const dialog = button?.closest('.modal')
            if(!dialog?.classList.contains('show')) return
            await new Promise(resolve => {
                dialog.addEventListener('hidden.bs.modal', resolve, {once: true})
                button.click()
            })
        },
        async ShowImportSummary(summary){
            const successful = Number(summary.successful || 0)
            const skipped = Number(summary.skipped || 0)
            const content = document.createElement('div')
            content.style.textAlign = 'left'
            const overview = document.createElement('p')
            overview.textContent = this.$i18n.t('Import summary message', {successful, skipped})
            content.appendChild(overview)
            if(Array.isArray(summary.skippedRows) && summary.skippedRows.length){
                const label = document.createElement('strong')
                label.textContent = this.$i18n.t('Skipped row details')
                content.appendChild(label)
                const details = document.createElement('ol')
                Object.assign(details.style, {maxHeight: '40vh', overflow: 'auto', paddingLeft: '1.5rem', fontSize: '0.85rem'})
                for(const row of summary.skippedRows){
                    const entry = document.createElement('li')
                    entry.textContent = `${row.sheet || 'Template'} ${this.$i18n.t('Row')} ${row.row}${row.costCode ? ' (' + row.costCode + ')' : ''}: ${row.reason || ''}`
                    details.appendChild(entry)
                }
                content.appendChild(details)
            }
            await this.$swal({
                title: this.$i18n.t(successful === 0 ? 'No rows imported' : skipped > 0 ? 'Import completed with skipped rows' : 'Import completed'),
                icon: skipped > 0 || successful === 0 ? 'warning' : 'success',
                html: content,
                width: 'min(42rem, 94vw)'
            })
        },
        OpenImportModal(){
            if(this.isImportRunning) return
            this.importError = ''
            this.isImportClicked = false
            this.newBoqImport = {
                importTemplateType : 1,
                file : null,
            }
            if(this.$refs.uploadFile){
                this.$refs.uploadFile.value = ''
            }
        },
        async ExportBoqList(){
            if(this.isExportRunning){ return }

            this.isExportRunning = true
            let shouldClose = false
            try{
                if(this.exportTemplateType <=2 && this.exportTemplateType>=1){
                    const status = await ExportHighLevelBoqLineItems(this.boqItem._id,this.exportTemplateType,this.boqItem.name)
                    if(typeof status === 'number'){
                        this.$swal(this.$i18n.t('Export Template'),this.$i18n.t('Error in Exporting Template'),'warning')
                    }else{
                        shouldClose = true
                    }
                }else{
                    this.$swal(this.$i18n.t('Export Template'),this.$i18n.t('Template not yet implemented'),'warning')
                }
            }finally{
                this.isExportRunning = false
                if(shouldClose){
                    this.$nextTick(()=>this.$refs.closeModalExportBoq.click())
                }
            }
        },
        async ImportBoqList(){
            let data = new FormData()
            const self = this

            if(self.isImportRunning){
                return
            }

            const file = self.$refs.uploadFile.files[0]
            const newData = self.newBoqImport
            self.isImportClicked = true
            self.importError = ''
            newData.file = file || null
            if(!file ){
                return
            }
            if(!self.isImportTemplateSelected){
                return
            }

            data.append('id',self.boqItem._id)
            data.append('type',newData.importTemplateType)
            data.append('template',file)

            if(newData.importTemplateType!=1){
                self.importError = self.$i18n.t('Sorry not yet implemented')
                return
            }
            self.isImportRunning = true
            self.isImportClicked = false
            let imported = false
            let summary = null
            try {
                const uploaded = await ImportHighLevelBoqLineItems(data)
                imported = uploaded === 'OK' || uploaded?.success === true
                summary = uploaded?.summary
                if(imported){
                    await self.ReloadData()
                    await self.CheckIfHaveUnassigned()
                }else{
                    self.importError = self.GetImportErrorMessage(uploaded)
                }
            } catch(error) {
                self.importError = self.$i18n.t(imported
                    ? 'Import saved but refresh failed'
                    : 'Import connection error message')
            } finally {
                self.isImportRunning = false
            }
            if(imported && !self.importError){
                await self.$nextTick()
                await self.CloseImportModal()
                if(summary) await self.ShowImportSummary(summary)
            }
        },
        OpenAddItemModal(){
            this.$refs.ModalNewLineItem.ClearData()
        },
        DownloadTemplate(){
            const self = this
            if(self.newBoqImport.importTemplateType==1)
                DownloadTemplate1()
            else
                self.$swal(self.$i18n.t('Download Template'),self.$i18n.t('Sorry not yet implemented'),'warning')
        },
        SendForApproval(){
            const self = this
            const swalTitleSendForApproval = self.$i18n.t('Send For Approval')

            if(!self.sectionList || self.sectionList.length==0){
                self.$swal(
                    swalTitleSendForApproval,
                    self.$i18n.t('Please add at least one section before sending this Bill of Quantity for approval.'),
                    'warning'
                )
                return
            }

            if(self.haveUnassignedLineItems){
                self.$swal(
                    swalTitleSendForApproval,
                    self.FormatUnassignedLineItemsMessage(self.unassignedLineItemsPreview),
                    'warning'
                )
                return
            }

            self.$router.push({name : 'HleApprovalSetup', query : { boqId : self.boqItem._id}})
        },
        async ReloadData(){
            const self = this
            const dataSections = await GetHleNewBoqCreatorSections(self.boqId) 
            self.sectionList = dataSections.sections
            self.overAllTotal = dataSections.overAllTotal
        },
        OpenAddNewSection(){
            this.newSection = {} 
        },
        async AddMainSection(){
            const self = this
            const data = self.newSection
            
            self.isActionClicked = true
            if(!self.isAddMainSectionReady){
                return
            }
            self.isActionClicked = false

            const created = await AddHleNewBoqCreatorSection({
                boqId : self.boqId,
                name : String(data.name || '').trim(),
                level : 1,
                sequence : self.sectionList.length, 
            })
            if(typeof created!=='object'){
                const isDuplicateSection = String(created).toLowerCase().includes('already exist')
                self.$swal({
                    icon : 'warning',
                    title : self.$i18n.t('Unable to Add Main Section'),
                    text : isDuplicateSection
                        ? self.$i18n.t('A main section with this name already exists. Please enter a different section name.')
                        : created,
                    confirmButtonText : self.$i18n.t('OK')
                })
                return
            }

            self.sectionList.push({
                id : created._id,
                name : data.name,
                level : 1,
                childs : []
            })
            self.$refs.closeBoQAddMainSectionModal.click()
        },
        OpenAddNewSubSection(element){
            this.isActionClicked = false
            this.newSubSection = {
                parentId : element.id,
                mainName : element.name,
                parent : element,
                level : element.level + 1
            }
        },
        async AddNewSubSection(){
            const self = this
            const data = self.newSubSection

            self.isActionClicked = true
            if(!self.isAddSubSectionReady){
                return
            }
            self.isActionClicked = false
            
            const created = await AddHleNewBoqCreatorSection({
                boqId : self.boqId,
                name : String(data.name || '').trim(),
                level : data.level,
                sequence : data.parent.childs.length,
                estimatedAmount : data.estimatedAmount,
                parent :  data.parent.id
            })
            if(typeof created!=='object'){
                const isDuplicateSection = String(created).toLowerCase().includes('already exist')
                self.$swal({
                    icon : 'warning',
                    title : self.$i18n.t('Unable to Add Sub Section'),
                    text : isDuplicateSection
                        ? self.$i18n.t('A sub section with this name already exists. Please enter a different section name.')
                        : created,
                    confirmButtonText : self.$i18n.t('OK')
                })
                return
            }

            data.parent.childs.push(
                {
                    id : created._id,
                    name : String(data.name || '').trim(),
                    level : data.level,
                    childs : []
                }
            )
            await self.ReloadData()
            
            self.$refs.closeBoQAddSubSectionModal.click()
        },
        DeleteMain(element,parent){
            const self = this
            self.$swal({
                title: self.$i18n.t('Delete Section'),
                text : element.name + ' ' + self.$i18n.t('Will be deleted'),
                showCancelButton: true,
                icon: 'warning',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm: () => DeleteHleNewBoqCreatorSection({id : element.id, boqId : self.boqId, level :element.level})
            }).then(async (res)=>{
                if(res.isConfirmed){
                    if(res.value=='OK'){
                        self.$swal(self.$i18n.t('Delete Section'),self.$i18n.t('Deleted Successfully'),'success')
                        if(parent){
                            const getIndex = parent.childs.findIndex(u=>u.id==element.id)
                            if(getIndex!=-1){
                                parent.childs.splice(getIndex,1)
                            }
                        }else{
                            const getIndex = self.sectionList.findIndex(u=>u.id==element.id)
                            if(getIndex!=-1){
                                self.sectionList.splice(getIndex,1)
                            }
                        }

                        const getUnassingedLineItem = await GetHighLevelBoqLineItemsByBits({
                            page : 1,
                            id :  self.boqId,
                            costCode : '',
                            area : '',
                            skip : 0,
                            take : 3
                        })
                        self.unassignedLineItemsPreview = Array.isArray(getUnassingedLineItem) ? getUnassingedLineItem : []
                        self.haveUnassignedLineItems = self.unassignedLineItemsPreview.length!=0

                    }else{
                        self.$swal(self.$i18n.t('Delete Section'),res.value,'warning')
                    }
                }
            })
        },
        OpenRename(element){
            this.renameSection = {
                id : element.id,
                level : element.level,
                name : element.name,
                expectedAmount : element.expectedAmount,
                object : element
            }
        },
        async RenameSection(){
            const self = this
            const data = self.renameSection
            self.isActionClicked = true
            if(!data.name){
                return
            }
            self.isActionClicked = false

            const updated = await UpdateHleNewBoqCreatorSectionName({
                id : data.id,
                boqId : self.boqId,
                level : data.level,
                expectedAmount : data.expectedAmount,
                name : data.name
            })
            
            if(updated!='OK'){
                self.$swal(self.$i18n.t('Update Section'),updated,'warning')
                return
            }

            await self.ReloadData()

            self.$refs.closeRenameSectionModal.click()
        },
        OnDragEnd(e){
            // Check if the target is a parent or child element
            let isParent = e.to.classList.contains("parent")
            if (isParent) {
                return false
            }
        },
        OnEnd(){
            this.haveMoved = true
        },
        CancelSaveSequence(){
            window.location.reload()
        },
        async SaveSequences(){
            const self = this

            //get the rows
            const data = JSON.parse(JSON.stringify(self.sectionList))
            let toBeUpdated = []

            let duplicateList = []

            const LoopData = async (rows, parentId)=>{
                let promise  = []
                for(let x = 0; x < rows.length; x++ ){
                    let row = rows[x]

                    const haveDuplicates = rows.find(u=>u.name.toLowerCase().trim()==row.name.toLowerCase().trim() && u.id!=row.id)
                    if(haveDuplicates){
                        if(duplicateList.findIndex(u=>u.toLowerCase().trim()==row.name.toLowerCase().trim())==-1){
                            duplicateList.push(row.name)
                        }
                    }

                    if(row.sequence!=x || parentId!=row.parent){
                        toBeUpdated.push({
                            id : row.id,
                            name : row.name,
                            parent : parentId,
                            level : row.level,
                            sequence : x
                        })
                    }
                    row.sequence = x
                    row.parent = parentId
                    if(row.childs.length!=0){
                        promise.push(LoopData(row.childs,row.id))
                    }
                }
                await Promise.all(promise)
            }
            await LoopData(data)
            const titleSwal = self.$i18n.t('Save Sequence')
            if(duplicateList.length!=0){
                
                self.$swal(titleSwal,  self.$i18n.t('Section(s)') + ' ' + duplicateList.join(',') 
                + '  ' + self.$i18n.t('have identical names within their parent section'),'warning')
                return
            }

            if(toBeUpdated.length!=0){
                const updated = await UpdateHleNewBoqCreatorSectionSequence({
                    boqId : self.boqId,
                    sections : toBeUpdated
                })

                if(updated!='OK'){
                    self.$swal(titleSwal, updated,'warning')
                }else{
                    self.$swal(titleSwal, self.$i18n.t('Updated Successfully'),'success')
                    self.sectionList = data
                    self.haveMoved = false
                }
            }
            

        },
        OpenMarkUp(element){
            this.markUpUpdate = {
                id : element.id,
                name : element.name,
                markUp : (element?.expectedMarkUp * 100) || 0,
            }
        },
        async UpdateMarkUp(){
            const self = this
            const data = self.markUpUpdate
            
            self.isActionClicked = true
            if(data.markUp < 0 || data.markUp > 100){
                return
            }
            self.isActionClicked = false

            const updated = await UpdateHleNewBoqCreatorSectionMarkUp({
                id : data.id,
                boqId : self.boqId,
                markUp : data.markUp
            })
            const swalTitle = self.$i18n.t('Update Section Mark Up')
            if(updated!='OK'){
                self.$swal(swalTitle,updated,'warning')
                return
            }
            self.$swal(swalTitle, self.$i18n.t('Updated Successfully'),'success')
            await self.ReloadData()


            self.$refs.closeBoQMarkUpUpdateModal.click()
        },
    },
    data(){
        return {
            hleProject : {},
            hleProjectId : this.$route.params.id ,
            lineItems : [],
            boqItem : {
                status : 1,
                currencyId  : {
                    sign : '',
                }
            },
            sectionList : [],
            boqUrlname : '',
            boqId : this.$route.params.boqId,
            ApprovalStageBoqObj : ApprovalStageBoqObj,
            BoqBuilderColumSizes : BoqBuilderColumSizes,
            ExportTemplates : ExportTemplates,
            exportTemplateType : 0,
            isExportRunning : false,
            newBoqImport: {
                importTemplateType : 0
            },
            isImportRunning : false,
            importError : '',
            isImportClicked : false,
            approvalItem : null,
            haveUnassignedLineItems : false,
            unassignedLineItemsPreview : [],
            haveMoved : false,
            overAllTotal : {},
            isActionClicked : false,
            renameSection : {},
            newSection : {},
            newSubSection : {},
            markUpUpdate : {},
        }
    }
}
</script>

<style scoped>
.hle-boq-builder-page--deluxe .hle-boq-builder-card,
.hle-boq-builder-page--deluxe .hle-boq-builder-card__header,
.hle-boq-builder-page--deluxe .hle-boq-builder-card__body,
.hle-boq-builder-page--deluxe .hle-boq-builder-alert,
.hle-boq-builder-page--deluxe .hle-boq-builder-alert__action,
.hle-boq-builder-page--deluxe .hle-boq-builder-table-wrap,
.hle-boq-builder-page--deluxe .hle-boq-builder-action,
.hle-boq-builder-page--deluxe :deep(.hle-boq-builder-template-group .hle-boq-builder-action) {
    border-radius: 0 !important;
}

.hle-import-modal__loading {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    border: 1px solid rgba(202, 80, 21, 0.28);
    border-radius: 0;
    padding: 0.8rem 0.9rem;
    background: #fff6ef;
    color: #6f3215;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.4;
}
.hle-import-modal__loading .spinner-border { flex: 0 0 auto; width: 1rem; height: 1rem; color: #ca5015; }
.hle-import-modal__error { padding: 0.8rem 0.9rem; border: 1px solid #e3b8bb; border-radius: 0; background: #fff1f2; color: #8e2430; font-size: 0.85rem; line-height: 1.5; overflow-wrap: anywhere; white-space: pre-line; }
</style>
